export class IneligibleError extends Error {
  constructor() {
    super('Ineligible');
  }
}
